import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { driver_handover_requests, driver_handover_targets, red_bag } from "../../../networking/urlEndPoints";
import Axios from "../../../networking/interceptor";

export const fetchRedBag = createAsyncThunk('fetchRedBag', async (requestData, { rejectWithValue }) => {
	try {
		const params = {
			pharmacy_id: requestData.pharmacy_id,
		};

		if (requestData.search) {
			params.search = requestData.search;
		}

		const response = await Axios.get(red_bag, { params });

		if (typeof requestData.setLoading === 'function') {
			requestData.setLoading(false);
		}

		return response.data;
	} catch (error) {
		if (typeof requestData.setLoading === 'function') {
			requestData.setLoading(false);
		}

		return rejectWithValue(error.response);
	}
});

export const fetchRedBagHandoverTargets = createAsyncThunk('fetchRedBagHandoverTargets', async (requestData, { rejectWithValue }) => {
	try {
		const response = await Axios.get(driver_handover_targets, {
			params: {
				pharmacy_id: requestData.pharmacy_id,
			},
		});

		return response.data;
	} catch (error) {
		return rejectWithValue(error.response);
	}
});

export const createRedBagHandover = createAsyncThunk('createRedBagHandover', async (requestData, { rejectWithValue }) => {
	try {
		const response = await Axios.post(driver_handover_requests, {
			pharmacy_id: requestData.pharmacy_id,
			target_type: requestData.target_type,
			target_id: requestData.target_id,
			send_to_all_instore: requestData.send_to_all_instore,
			handover_type: 'red_bag',
			patient_id: requestData.patient_id,
			winrx_data_ids: requestData.winrx_data_ids,
			frequency_dose_ids_by_winrx_id: requestData.frequency_dose_ids_by_winrx_id,
			message: requestData.message,
			source_pharmacist_id: requestData.source_pharmacist_id,
			signature_base64: requestData.signature_base64,
		});

		return response.data;
	} catch (error) {
		return rejectWithValue(error.response);
	}
});

const initialState = {
	loading: false,
	data: [],
	error: null,
	pagination: null,
	handoverTargets: null,
	handoverTargetsLoading: false,
	handoverTargetsError: null,
	handoverLoading: false,
	handoverError: null,
}

const redBagSlice = createSlice({
	name: 'redBag',
	initialState,
	reducers: {
		clearRedBagData(state) {
			state.data = [];
			state.pagination = null;
		}
	},
	extraReducers: (builder) => {
		builder.addCase(fetchRedBag.pending, (state) => {
			return {
				...state,
				loading: true,
				error: null,
			};
		});
		builder.addCase(fetchRedBag.fulfilled, (state, action) => {
			return {
				...state,
				loading: false,
				data: action.payload?.data?.data || [],
				pagination: action.payload?.data?.pagination || null,
				error: null,
			};
		});
		builder.addCase(fetchRedBag.rejected, (state, action) => {
			return {
				...state,
				loading: false,
				error: action.payload,
				data: [],
				pagination: null,
			};
		});
		builder.addCase(fetchRedBagHandoverTargets.pending, (state) => {
			return {
				...state,
				handoverTargetsLoading: true,
				handoverTargetsError: null,
			};
		});
		builder.addCase(fetchRedBagHandoverTargets.fulfilled, (state, action) => {
			return {
				...state,
				handoverTargetsLoading: false,
				handoverTargets: action.payload?.data || null,
				handoverTargetsError: null,
			};
		});
		builder.addCase(fetchRedBagHandoverTargets.rejected, (state, action) => {
			return {
				...state,
				handoverTargetsLoading: false,
				handoverTargetsError: action.payload,
			};
		});
		builder.addCase(createRedBagHandover.pending, (state) => {
			return {
				...state,
				handoverLoading: true,
				handoverError: null,
			};
		});
		builder.addCase(createRedBagHandover.fulfilled, (state) => {
			return {
				...state,
				handoverLoading: false,
				handoverError: null,
			};
		});
		builder.addCase(createRedBagHandover.rejected, (state, action) => {
			return {
				...state,
				handoverLoading: false,
				handoverError: action.payload,
			};
		});
	}
});

export const { clearRedBagData } = redBagSlice.actions;

export default redBagSlice.reducer;
